import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'
import { scrubOnboardingHandoffTokenFromUrl } from '@/lib/onboarding-auth-handoff'
import { initPostHog, registerPostHogAnalyticsBridge } from '@/lib/posthog'
import { scrubRenewalTokenFromUrl } from '@/lib/renewal-payment'

scrubOnboardingHandoffTokenFromUrl()
scrubRenewalTokenFromUrl()
initPostHog()
registerPostHogAnalyticsBridge()

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
)
